import React from "react";
import { ProviderProps } from "../common/types";
import { PreferencesProvider } from "./preferences/context";

export const JulebProvider: React.FC<ProviderProps> = (
  props: ProviderProps,
) => {
  return <PreferencesProvider>{props.children}</PreferencesProvider>;
};
